import { createContext, useState, useCallback, useEffect, useRef } from "react";
import { getArgentinaTime } from "../utils/mobile";

export const NowContext = createContext({
  now: null,
  setNow: () => {},
  serverTimeOffset: 0,
  updateServerTimeOffset: () => {},
  forceUpdateTime: () => {},
});

export const NowProvider = ({ children }) => {
  const [now, setNow] = useState(() => Date.now());
  const [serverTimeOffset, setServerTimeOffset] = useState(0);
  const offsetRef = useRef(0);

  const updateServerTimeOffset = useCallback((serverUnixMs) => {
    if (serverUnixMs) {
      const offset = serverUnixMs - Date.now();
      offsetRef.current = offset;
      setServerTimeOffset(offset);
    }
  }, []);

  const forceUpdateTime = useCallback(async () => {
    try {
      const response = await getArgentinaTime();
      setNow(response);
      updateServerTimeOffset(response);
      return response;
    } catch (error) {
      console.error("Error al obtener la hora de Argentina:", error);
      throw error;
    }
  }, [updateServerTimeOffset]);

  // Reloj server-corregido, igual que la app mobile: `now` avanza tic a tic
  // usando la hora de Argentina en vez del reloj del dispositivo. Así el
  // estado de finalizada/activa y los countdowns quedan sincronizados.
  useEffect(() => {
    const tick = () => {
      setNow(Date.now() + offsetRef.current);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const value = {
    now,
    setNow,
    serverTimeOffset,
    updateServerTimeOffset,
    forceUpdateTime,
  };

  return <NowContext.Provider value={value}>{children}</NowContext.Provider>;
};
